import React from 'react';

import StatusTag from 'scouting-ui/lib/StatusTag';

import { advancementStatusToTagStatus } from '@shared/utils/advancementStatus';

interface AdvancementStatusTagProps {
  status?: string | null;
}

export function AdvancementStatusTag({ status }: AdvancementStatusTagProps) {
  return <StatusTag status={advancementStatusToTagStatus(status ?? '')} />;
}
